import React, { useEffect, useRef, useState } from 'react'
import { useModals } from '../../hooks/useModals'
import ConfirmModalContent from '../ConfirmModalContent/ConfirmModalContent'
import DynamicFaIcon from '../DynamicFaIcon/DynamicFaIcon'

export interface ActionOption {
    action: () => void
    text: string
    type?: 'danger' | string
    contextType?: string
    showConfirmModal?: boolean
}

interface ActionButtonProps {
    options: ActionOption[]
}

const ActionButton: React.FunctionComponent<ActionButtonProps> = ({ options }: ActionButtonProps) => {
    const [actionButtonClicked, setActionButtonClicked] = useState<boolean>(false)
    const clickOutsideRef = useRef<any>()

    const { showModal, RenderModals } = useModals([
        {
            id: 'confirm',
            comp: ConfirmModalContent,
            props: {}
        }
    ])

    useEffect(() => {
        document.addEventListener('click', clickOutside)

        return () => {
            document.removeEventListener('click', clickOutside)
        }
    }, [])

    const clickOutside = (event: any) => {
        if (clickOutsideRef.current && !clickOutsideRef.current.contains(event.target)) {
            setActionButtonClicked(false)
        }
    }

    const handleAction = (option: ActionOption) => {
        if (option.showConfirmModal !== false) {
            showModal('confirm', {
                title: 'Weet je het zeker?',
                subtitle: `Weet je het zeker dat je deze ${option.contextType} wilt ${option.text}?`,
                primaryButtonText: option.text,
                primaryButtonAction: option.action,
                secondaryButtonText: 'Nee, sluiten',
                // onRequestClose: () => {},
                onConfirm: () => option.action()
            })
        } else {
            option.action()
        }
    }

    if (!options.length) {
        return null
    }

    return (
        <div className='relative' ref={clickOutsideRef}>
            <RenderModals />

            <button
                type='button'
                className='-m-2 rounded p-2 cursor-pointer transition-colors hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-[--tb-primary]'
                onClick={() => setActionButtonClicked(!actionButtonClicked)}
                aria-label='Actiemenu openen'
                aria-expanded={actionButtonClicked}
            >
                <DynamicFaIcon iconName='ellipsis' />
            </button>
            {actionButtonClicked && (
                <div className='absolute right-0 bottom-full z-10 mb-2 cursor-pointer rounded-md border bg-white'>
                    {options.map((option: ActionOption, i: number) => {
                        const textColor = option.type === 'danger' ? 'text-red-500' : 'text-[--tb-text]'

                        return (
                            <div key={i} className='border-t first:border-t-0'>
                                <button
                                    type='button'
                                    className={`w-full px-8 py-2 text-left cursor-pointer capitalize transition-colors hover:bg-tibi-blushPrimary focus:outline-none focus-visible:bg-tibi-blushPrimary ${textColor}`}
                                    onClick={() => handleAction(option)}
                                >
                                    {option.text}
                                </button>
                            </div>
                        )
                    })}
                </div>
            )}
        </div>
    )
}

export default ActionButton
